import { Canvas } from '@modules/canvas/components';
import { useKeyboardEvents } from '../hooks/useKeyboardEvents';   
import { useLoD } from '@modules/lod/useLoD';

export const Workspace = () => {
  useKeyboardEvents();
  useLoD();

  return <Canvas />;
};
